import Pusher from "pusher-js";

export const pusher = new Pusher("20aacc2b7df2c1299b22", {
    cluster: "mt1",
});
